// extracted by mini-css-extract-plugin
export default {"history":"CampaignLogs_history__nwegM"};